import { Injectable } from "@angular/core";
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { AppConstants } from "src/app/app.constants";

@Injectable()
export class TokenGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): boolean {
    if (localStorage.getItem("registration-token")) {
      return true;
    } else if (route.queryParamMap.get("token")) {
      localStorage.setItem("registration-token", route.queryParamMap.get("token")!);
      return true;
    } else {
      window.location.href = AppConstants.LOGIN_PAGE_URL;
      return false;
    }
  }
}
